import IntlMessage from '../../../helpers/intlMessage';
import React from 'react';

export const colorsSystem = {
  AZUL: '#3076a8',
  AMARELO: '#f1d159',
  VERMELHO: '#f15959',
  LARANJA: '#ff7214',
  VERDE: '#5aba71',
  DG1: '#2B56A1',
  DG2: '#3264BA',
  DG3: '#3972D4',
  DG4: '#407EEC',
  DG5: '#367DF8',
};

export const tipoDescarteEmum = {
  PADRAO: 0,
  ESPECIAL: 1,
  SEPULTAMENTO: 2,
  SEPULTAMENTO_INDIVIDUAL: 3,
};

export const tipoDescarteOptions = [

  {
    value: tipoDescarteEmum.PADRAO,
    label: <IntlMessage id = "dashboards.disposalMaterials.standardDiscard"/>
  },
  {
    value: tipoDescarteEmum.ESPECIAL,
    label: <IntlMessage id = "dashboards.disposalMaterials.specialDisposal"/>,
  },
  {
    value: tipoDescarteEmum.SEPULTAMENTO,
    label: <IntlMessage id = "dashboards.disposalMaterials.burialDisposal"/>,
  },
  {
    value: tipoDescarteEmum.SEPULTAMENTO_INDIVIDUAL,
    label: <IntlMessage id = "dashboards.disposalMaterials.burialReport"/>,
  },
];

export const optionsFiltroDescarte = [
  { value: 'dtpedido', label: 'dashboards.disposalMaterials.requestDate' },
  { value: 'dtdescarte', label: 'dashboards.disposalMaterials.discardDate' },
  { value: 'dtvencimento', label: 'dashboards.disposalMaterials.dueDate' },
  { value: 'dtsolicitacao', label: 'dashboards.disposalMaterials.dateSolicitation' },
  { value: 'descricao', label: 'dashboards.disposalMaterials.materialDescription' },
  { value: 'diasavencer', label: 'dashboards.disposalMaterials.daysExpire' },
  { value: 'idfrasco', label: 'dashboards.disposalMaterials.bottleIdentification' },
  { value: 'nrExame', label: 'dashboards.disposalMaterials.examNumber' },
  { value: 'nrPedido', label: 'dashboards.disposalMaterials.requestNumber' },
  { value: 'paciente', label: 'dashboards.disposalMaterials.patient' },
];

export const etapasEnum = {
  MATERIAL: 'MATERIAL',
  MACRO: 'MACRO',
  MICRO: 'MICRO',
  HISTO: 'HISTO',
  IMUNO: 'IMUNO',
  FISH: 'FISH',
  CISH: 'CISH',
  PCR: 'PCR',
  CONGELACAO: 'CONGELACAO',
  NOTAS: 'NOTAS',
  CONCLUSAO: 'CONCLUSAO',
  ERRATA: 'ERRATA',
};

export const etapasIndexEnum = {
  MATERIAL: '0',
  MACRO: '1',
  MICRO: '2',
  HISTO: '3',
  IMUNO: '4',
  FISH: '5',
  CISH: '6',
  PCR: '7',
  CONGELACAO: '8',
  NOTAS: '9',
  CONCLUSAO: '10',
  ERRATA: '11',
};

export const statusEtapasEnum = {
  REALIZADO: 'realizado',
  CONCLUIDO: 'concluido',
  REVISAO: 'revisao',
  PENDENTE: 'pendente',
  NAO_REALIZADO: 'naorealizado',
  NAO_APLICAVEL: 'naoaplicavel',
  NAO_CONFORMIDADE: 'naoconformidade',
  CONFERENCIA: 'conferencia',
};

export const tipoMedicoEnum = {
  MEDICO: 'medico',
  REVISOR: 'revisor',
};

export const quadroKanbanEnum = {
  // Histologia Inclusao //
  HI_CASSETE: { id: 'cassetes', icone: 'fas fa-th', status: 'N' },
  HI_EXECUTANDO: { id: 'executando', icone: 'fas fa-tasks', status: 'A' },
  HI_BLOCOS: { id: 'blocos', icone: 'fas fa-cube', status: 'F' },

  // Histologia Lamina //
  HL_BLOCOS: { id: 'blocos', icone: 'fas fa-cube' },
  HL_PENDENTES: { id: 'pendente', icone: 'far fa-clock', status: 'N' },
  HL_EXECUTANDO: { id: 'executando', icone: 'fas fa-tasks', status: 'A' },
  HL_PRONTAS: { id: 'laminas', icone: 'fab fa-buffer', status: 'F' },

  // Citologia //
  CG_PENDENTES: { id: 'pendente', icone: 'far fa-clock', status: 'N' },
  CG_EXECUTANDO: { id: 'executando', icone: 'fas fa-tasks', status: 'A' },
  CG_PRONTAS: { id: 'concluidas', icone: 'fab fa-buffer', status: 'F' },

  // Imuno //
  IM_PENDENTES: { id: 'pendente', icone: 'far fa-clock', status: 'N' },
  IM_EXECUTANDO: { id: 'executando', icone: 'fas fa-tasks', status: 'A' },
  IM_PRONTAS: { id: 'concluidas', icone: 'fab fa-buffer', status: 'F' },

  // Tarefas Medico //
  TM_PENDENTES: { id: 'pendentesDeRevisao', status: 'REVISAO' },
  TM_PENDENTESEXUCUCAO: { id: 'pendentesDeExecucao', status: 'PENDENTE' },
  TM_REVISADOS: { id: 'revisadosConcluidos', status: 'CONCLUIDO' },

  // Arquivamento //
  AM_SOLICITADOS: { id: 'pendentes', status: 0 },
  AM_ARQUIVADOS: { id: 'arquivados', status: 1 },

  // Requisição Materiais //
  RM_SOLICITADOS: { id: 'pendentes', status: 0 },
  RM_CONCLUIDOS: { id: 'arquivados', status: 1 },
};

export const rotaEnum = {
  HOME: '/',
  GRAFICOS: 'graficos',
  HISTOLOGIA: 'histologia',
  CITOLOGIA: 'citologia',
  IMUNOLOGIA: 'imunologia',
  CONTROLETAREFAS: 'controle-tarefas',
  TAREFASMEDICO: 'tarefas-medico',
  DESCARTE: 'descarte-material',
  ARQUIVAMENTO: 'arquivamento',
  ERROR: 'error',
  LAUDO: 'laudo',
  LOGIN: 'LOGIN',
  CONFIG: 'configuracao',
  RELATORIOS: 'relatorios',
  SOLICITACOES: 'solicitacoes',
};

export const enumFiltroTipo = {
  DATA_ENTREGA: 'dtEntregra',
  DATA_SOLICITACAO: 'dtSolicitacao',
  NR_EXAME: 'nrExame',
  NR_PEDIDO: 'nrPedido',
  NOME_PACIENTE: 'nomePaciente',
  OBSERVACAO_LAUDO: 'obsLaudo',
  TIPO_EXAME: 'tipoExame',
  URGENTE: 'urgente',
  DATA_PREVISTA_ENTREGA: 'dtPrevistaEntrega',
  DATA_PEDIDO: 'dtPedido',
  SOLICITANTE: 'nomeSolicitante',
  PRONTUARIO: 'nrProntuario'
};

export const enumFiltroTipoList = [
  { label:<IntlMessage id = "dashboards.reports.deliveryDate"/>, value: enumFiltroTipo.DATA_ENTREGA },
  { label: <IntlMessage id = "dashboards.reports.requestDate"/>, value: enumFiltroTipo.DATA_SOLICITACAO },
  { label: <IntlMessage id = "dashboards.reports.examNumber"/>, value: enumFiltroTipo.NR_EXAME },
  { label: <IntlMessage id = "dashboards.reports.requestNumber"/>, value: enumFiltroTipo.NR_PEDIDO },
  { label: <IntlMessage id = "dashboards.reports.patientName"/>, value: enumFiltroTipo.NOME_PACIENTE },
  { label: <IntlMessage id = "dashboards.reports.observationReport"/>, value: enumFiltroTipo.OBSERVACAO_LAUDO },
  { label: <IntlMessage id = "dashboards.reports.examType"/>, value: enumFiltroTipo.TIPO_EXAME },
  { label: <IntlMessage id = "dashboards.reports.urgent"/>, value: enumFiltroTipo.URGENTE },
];

export const enumFiltroPesquisa = [

  { label: 'Accession number', id: 11, value: 'dashboards.general.accessionNumber' },
  { label: 'Atendimento', id: 13, value: 'dashboards.general.attendance' },
  { label: 'Ativo', id: 28, value: 'dashboards.general.active' },
  { label: 'Cartão nacional SUS', id: 10, value: 'dashboards.general.SUSnationalCard' },
  { label: 'Convênio', id: 16, value: 'dashboards.general.healthInsurance' },
  { label: 'CPF', id: 34, value: 'dashboards.general.CPF' },
  { label: 'Data de entrega', id: 23, value: 'dashboards.general.deliveryDate' },
  { label: 'Data de liberação', id: 31, value: 'dashboards.general.releaseDate' },
  { label: 'Data de não conformidade', id: 25, value: 'dashboards.general.datenonCompliance' },
  { label: 'Data de nascimento', id: 35, value: 'dashboards.general.birthDate' },
  { label: 'Data de solicitação', id: 24, value: 'dashboards.general.requestDate' },
  { label: 'Diagnóstico', id: 5, value: 'dashboards.general.diagnosis' },
  { label: 'Encaminhamento', id: 4, value: 'dashboards.general.forwarding' },
  { label: 'Exames', id: 1, value: 'dashboards.general.exams' },
  { label: 'Grupo exame', id: 17, value: 'dashboards.general.examGroup' },
  { label: 'Laudo', id: 2, value: 'dashboards.general.report' },
  { label: 'Matrícula SAME', id: 15, value: 'dashboards.general.sameEnrollment' },
  { label: 'Médico executante', id: 0, value: 'dashboards.general.performingPhysician' },
  { label: 'Médico revisor', id: 19, value: 'dashboards.general.medicalReviewer' },
  { label: 'Médico solicitante', id: 18, value: 'dashboards.general.requestingDoctor' },
  { label: 'Não conformidade', id: 6, value: 'dashboards.general.nonCompliance' },
  { label: 'Nº Exame Externo', id: 32, value: 'dashboards.general.externalExamNo' },
  { label: 'Número exame', id: 8, value: 'dashboards.general.examNumber' },
  { label: 'Número pedido', id: 9, value: 'dashboards.general.orderNumber' },
  { label: 'Observação do Laudo', id: 33, value: 'dashboards.general.observationReport' },
  { label: 'Paciente', id: 12, value: 'dashboards.general.pacient' },
  { label: 'Procedimento', id: 20, value: 'dashboards.general.procedure' },
  { label: 'Prontuário', id: 14, value: 'dashboards.general.medicalRecord' },
  { label: 'Resolução não conformidade', id: 26, value: 'dashboards.general.nonconformityResolution' },
  { label: 'Setor solicitante', id: 7, value: 'dashboards.general.requestingSector' },
  { label: 'Status da etapa', id: 22, value: 'dashboards.general.stepStatus' },
  { label: 'Tipo exame', id: 3, value: 'dashboards.general.examType' },
  { label: 'Tipo não conformidade', id: 27, value: 'dashboards.general.nonconformityType' },
  { label: 'Topografia', id: 30, value: 'dashboards.general.topography' },
  { label: 'Unidade atendimento', id: 21, value: 'dashboards.general.serviceUnit' },
  { label: 'Urgente', id: 29, value: 'dashboards.general.urgent' },
];

export const enumFiltroTipoExam = [
  { label: <IntlMessage id = "dashboards.reports.exam"/>, value: enumFiltroTipo.NR_EXAME },
  { label: <IntlMessage id = "general.requestsPanel.patient"/>, value: enumFiltroTipo.NOME_PACIENTE },
  { label: <IntlMessage id = "dashboards.general.requestDate"/>, value: enumFiltroTipo.DATA_SOLICITACAO },
];

export const enumFiltroTipoCertificacao = [
  { label: <IntlMessage id = "dashboards.reports.examNumber"/>, value: enumFiltroTipo.NR_EXAME },
  { label: <IntlMessage id = "general.requestsPanel.patient"/>, value: enumFiltroTipo.NOME_PACIENTE },
  { label: <IntlMessage id = "dashboards.general.requestDate"/>, value: enumFiltroTipo.DATA_SOLICITACAO },
  { label:<IntlMessage id = "dashboards.reports.deliveryDate"/>, value: enumFiltroTipo.DATA_ENTREGA },
  { label: <IntlMessage id = "dashboards.reports.requestNumber"/>, value: enumFiltroTipo.NR_PEDIDO },
  { label: <IntlMessage id = "dashboards.reports.examType"/>, value: enumFiltroTipo.TIPO_EXAME },
  { label: <IntlMessage id = "dashboards.reports.urgent"/>, value: enumFiltroTipo.URGENTE },
  { label: <IntlMessage id = "dashboards.reports.observationReport"/>, value: enumFiltroTipo.OBSERVACAO_LAUDO },
];

export const enumFiltroCertificacao = [
  { label: <IntlMessage id = "dashboards.examDetail.certificate"/>, value: true },
  { label: <IntlMessage id = "dashboards.examDetail.noCertificate"/>, value: false },
];

export const enumFiltroListUrgente = [
  { label: <IntlMessage id = "dashboards.reports.yes"/>, value: true },
  { label: <IntlMessage id = "dashboards.reports.no"/>, value: false },
];

export const enumFiltroListOrder = (intl) => {
  return [
    {label: `${intl.formatMessage({id:"dashboards.general.expectedDelivery"})}`, value: enumFiltroTipo.DATA_PREVISTA_ENTREGA},
    {label: `${intl.formatMessage({id:"dashboards.general.requestDate"})}`, value: enumFiltroTipo.DATA_PEDIDO},
    {label: `${intl.formatMessage({id:"dashboards.general.deliveryDate"})}`, value: enumFiltroTipo.DATA_ENTREGA},
    {label: `${intl.formatMessage({id:"dashboards.general.urgent"})}`, value: enumFiltroTipo.URGENTE},
    {label: `${intl.formatMessage({id:"dashboards.general.immunohistochemistryTests"})}`, value: etapasEnum.IMUNO.toLowerCase()}
  ];
}

export const enumFiltroRelatorioLaudoSemCidListOrder = (intl) => {
  return [
    {label: `${intl.formatMessage({id:"dashboards.disposalMaterials.requestDate"})}`, value: enumFiltroTipo.DATA_PEDIDO},
    {label: `${intl.formatMessage({id:"dashboards.examDetail.requester"})}`, value: enumFiltroTipo.SOLICITANTE},
    {label: `${intl.formatMessage({id:"dashboards.general.examNumber"})}`, value: enumFiltroTipo.NR_EXAME},
    {label: `${intl.formatMessage({id:"dashboards.general.pacient"})}`, value: enumFiltroTipo.NOME_PACIENTE},
    {label: `${intl.formatMessage({id:"dashboards.general.medicalRecord"})}`, value: enumFiltroTipo.PRONTUARIO}
  ];
}

export const retornaStatusFormatado = (status, messages) => {
  switch (status) {
    case statusEtapasEnum.NAO_CONFORMIDADE:
      return messages ? messages['dashboards.examDetails.status.nonCompliance'] : 'dashboards.examDetails.status.nonCompliance';
    case statusEtapasEnum.NAO_REALIZADO:
      return messages ? messages['dashboards.examDetails.status.nochecked'] : 'dashboards.examDetails.status.nochecked';
    case statusEtapasEnum.PENDENTE:
      return messages ? messages['dashboards.examDetails.status.pending'] : 'dashboards.examDetails.status.pending';
    case statusEtapasEnum.REALIZADO:
      return messages ? messages['dashboards.examDetails.status.checked'] : 'dashboards.examDetails.status.checked';
    case statusEtapasEnum.REVISAO:
      return messages ? messages['dashboards.examDetails.status.revision'] : 'dashboards.examDetails.status.revision';
    case statusEtapasEnum.NAO_APLICAVEL:
      return messages ? messages['dashboards.examDetails.status.notApplicable'] : 'dashboards.examDetails.status.notApplicable';
    case statusEtapasEnum.CONFERENCIA:
      return messages ? messages['dashboards.examDetails.status.lecturer'] : 'dashboards.examDetails.status.lecturer';
    default:
      return status;
  }
};

export const retornaEtapaFormatada = (etapa, messages) => {
  switch (etapa) {
    case etapasEnum.MATERIAL:
      return messages ? messages['dashboards.examDetails.step.material'] : 'dashboards.examDetails.step.material';
    case etapasEnum.MACRO:
      return messages ? messages['dashboards.examDetails.step.macro'] : 'dashboards.examDetails.step.macro';
    case etapasEnum.MICRO:
      return messages ? messages['dashboards.examDetails.step.micro'] : 'dashboards.examDetails.step.micro';
    case etapasEnum.IMUNO:
      return messages ? messages['dashboards.examDetails.step.imuno'] : 'dashboards.examDetails.step.imuno';
    case etapasEnum.HISTO:
      return messages ? messages['dashboards.examDetails.step.histo'] : 'dashboards.examDetails.step.histo';
    case etapasEnum.CISH:
      return messages ? messages['dashboards.examDetails.step.cish'] : 'dashboards.examDetails.step.cish';
    case etapasEnum.FISH:
      return messages ? messages['dashboards.examDetails.step.fish'] : 'dashboards.examDetails.step.fish';
    case etapasEnum.PCR:
      return messages ? messages['dashboards.examDetails.step.pcr'] : 'dashboards.examDetails.step.pcr';
    case etapasEnum.CONGELACAO:
      return messages ? messages['dashboards.examDetails.step.congelacao'] : 'dashboards.examDetails.step.congelacao';
    case etapasEnum.CONCLUSAO:
      return messages ? messages['dashboards.examDetails.step.conclusao'] : 'dashboards.examDetails.step.conclusao';
    case etapasEnum.ERRATA:
      return messages ? messages['dashboards.examDetails.step.errata'] : 'dashboards.examDetails.step.errata';
    default:
      return etapa;
  }
};

export const retornaFiltroFormatado = (filtro, messages) => {
  filtro.filtros.map((item) => {
    const currentFilter = enumFiltroPesquisa.find(x=> x.id == item.id);
    if(currentFilter){
      item['value'] =  messages[currentFilter.value];
    }
   }
  );
  return filtro;
};


// WEBPACK FOOTER //
// ./src/app/common/util/defaultValues.js